import { render } from "./MaterialNotes.vue?vue&type=template&id=7082c2c3&scoped=true"
import script from "./MaterialNotes.vue?vue&type=script&lang=js"
export * from "./MaterialNotes.vue?vue&type=script&lang=js"

import "./MaterialNotes.vue?vue&type=style&index=0&id=7082c2c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7082c2c3"]])

export default __exports__